import { Wrapper } from '@american-autonomy/ag-ui';

import FormErrors from 'components/FormErrors';
import ButtonSubtext from 'components/buttons/ButtonSubtext';
import ErrorButton from 'components/buttons/ErrorButton';
import PrimaryButton from 'components/buttons/PrimaryButton';
import Panel from 'components/containers/Panel';

import useTranslation from './hooks/useTranslation';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const FormSubmitPanel: FunctionComponent<Props> = ({
    buttonText,
    className,
    disabled,
    errors,
    nextText,
    onSubmit,
    testId = TEST_ID
}) => {
    const { ENTER } = useTranslation();

    const hasErrors = errors && Object.keys(errors).length > 0;

    return (
        <Panel className={className} testId={testId}>
            {hasErrors ? (
                <Wrapper>
                    <ErrorButton className={styles.errorButton} text={buttonText || ENTER} />

                    <FormErrors errors={errors} />
                </Wrapper>
            ) : (
                <Wrapper className={styles.wrapper}>
                    <PrimaryButton
                        isDisabled={disabled}
                        onClick={onSubmit}
                        text={buttonText || ENTER}
                    />

                    {nextText && <ButtonSubtext text={nextText} />}
                </Wrapper>
            )}
        </Panel>
    );
};

export default FormSubmitPanel;
